import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';

interface IOwnProps extends InputProps {
  name: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  tooltip?: string;
  placeholderLabel: string;
  onlyNumber?: boolean;
  mask?: string;
  isRequired?: boolean;
  onClickRightIcon?(): void;
}

const InputMobile: React.FC<IOwnProps> = (props) => {
  const { formState, register, watch } = useFormContext();

  const { iconLeft, iconRight, tooltip, placeholderLabel, name = '', onlyNumber, isRequired, ...rest } = props;

  const errorMessage = formState.errors?.[name]?.message?.toString();

  return (
    <FormControl
      isInvalid={!!errorMessage}
      sx={{
        transition: 'padding-top 0.2s ease',
        '&:has(input:focus), &:has(input:not(:placeholder-shown))': {
          paddingTop: '0.8rem',
        },
      }}
      isRequired={isRequired}
      position="relative"
    >
      <InputGroup size="sm">
        {iconLeft && <InputLeftElement pointerEvents="none" children={iconLeft} />}
        <Input
          as={props.mask ? ReactInputMask : undefined}
          onInput={
            onlyNumber
              ? (e) => {
                  e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, '');
                }
              : undefined
          }
          inputMode={onlyNumber ? 'numeric' : 'text'}
          {...register(name)}
          placeholder=" "
          size="sm"
          variant="flushed"
          isRequired={false}
          {...(props.mask && { value: watch(name) || '' })}
          className="peer"
          {...rest}
        />
        <FormLabel
          htmlFor="expedicao"
          position="absolute"
          left="2rem"
          top="50%"
          transform="translateY(-50%)"
          color="gray.500"
          fontSize="sm"
          transition="all 0.2s ease"
          pointerEvents="none"
          css={{
            '.peer:not(:placeholder-shown) ~ &, .peer:focus ~ &': {
              fontSize: '0.6rem',
              left: '0rem',
              top: '-4px',
            },
            '.peer:focus:not(:placeholder-shown) ~ &': {
              color: '#009ac0',
            },
          }}
        >
          {placeholderLabel}
        </FormLabel>
        {(tooltip && (
          <Box
            as="span"
            position="relative"
            _after={{
              content: `'${tooltip}'`,
              position: 'absolute',
              bottom: '-13px',
              right: 1,
              background: '#222',
              color: 'white',
              px: '6px',
              py: '2px',
              borderRadius: '4px',
              fontSize: '10px',
              whiteSpace: 'nowrap',
              opacity: 0,
              transform: 'translateY(5px)',
              pointerEvents: 'none',
              transition: 'opacity 0.2s ease, transform 0.2s ease',
            }}
            _before={{
              content: '""',
              position: 'absolute',
              bottom: 1.5,
              right: '11px',
              borderWidth: '5px',
              borderStyle: 'solid',
              borderColor: ' transparent  transparent #222 transparent',
              opacity: 0,
              transform: 'translateY(5px), translateX(90deg)',
              transition: 'opacity 0.2s ease, transform 0.2s ease',
              zIndex: 3,
            }}
            _hover={{
              _after: { opacity: 1, transform: 'translateY(0)' },
              _before: { opacity: 1, transform: 'translateY(0)' },
            }}
          >
            <InputRightElement>
              {iconRight && <InputRightElement pointerEvents="none" children={iconRight} />}
            </InputRightElement>
          </Box>
        )) ||
          (iconRight && <InputRightElement onClick={props.onClickRightIcon} children={iconRight} />)}
      </InputGroup>
      {errorMessage && <FormErrorMessage fontSize="0.78rem">{errorMessage}</FormErrorMessage>}
    </FormControl>
  );
};

export default InputMobile;
